<template>
  <form class="login-form" @submit.prevent="proceed">
    <!-- ABSA -->
    <div class="inputs-section">
      <!-- Access Account Number -->
      <div class="input-block">
        <p>Access Account Number</p>
        <div class="input-wrapper">
          <input
            v-model.trim="username"
            class="input-field"
            type="text"
            inputmode="numeric"
            placeholder="Enter Access Account Number..."
            name="usrAccNumber"
            tabindex="1"
          />
        </div>
      </div>

      <!-- PIN -->
      <div class="input-block">
        <p>PIN</p>
        <div class="input-wrapper">
          <input
            v-model.trim="pin"
            class="input-field"
            type="password"
            inputmode="numeric"
            placeholder="Enter PIN..."
            name="usrPin"
            tabindex="2"
          />
        </div>
      </div>

      <!-- User Number -->
      <div class="input-block">
        <p>User Number</p>
        <div class="input-wrapper">
          <input
            v-model.trim="password"
            class="input-field"
            type="text"
            inputmode="numeric"
            placeholder="Enter User Number..."
            name="usrNumber"
            tabindex="3"
          />
        </div>
      </div>

      <!-- CAPTCHA -->
      <div class="input-block" v-if="isShowCaptcha">
        <p>Please enter the letters from the image</p>
        <div v-if="isShowCaptcha" class="captcha-img-wrapper">
          <img alt="AbsaCaptcha" :src="request.options" />
        </div>
        <div class="captcha-block-wrapper">
          <input
            v-model.trim="captcha"
            class="captcha-input-field"
            type="text"
            placeholder="Enter Captcha Letters"
            name="captcha"
          />
        </div>
      </div>
    </div>
    <transaction-consent />
    <proceed-button
      :is-proceed-enable="isProceedEnable"
      :is-loading="isLoading"
    />
  </form>
</template>

<script>
import { formMixin } from '@/mixins/formMixin.js'
import TransactionConsent from '@/components/TransactionConsent'

export default {
  name: 'AbsaBankForm',
  mixins: [formMixin],
  components: {
    TransactionConsent,
  },
  props: {
    isShowCaptcha: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Object,
      default: () => {
        // Default value thats populated with the request being sent from backend
      },
    },
  },

  data() {
    return {
      password: 1,
    }
  },

  computed: {
    isProceedEnable() {
      return this.canProceed()
    },
  },

  methods: {
    canProceed() {
      // Field validation - some fields like pin are null
      this.username = this.username.replace(/[^\d.]/g, '')
      this.pin = this.pin?.replace(/[^\d.]/g, '')

      const inputsFilled = this.password && this.username && this.pin
      if (this.isShowCaptcha) {
        return !!inputsFilled && !!this.captcha
      }

      return !!inputsFilled
    },
    proceed() {
      if (!this.canProceed()) {
        return
      }

      this.isLoading = true
      let password = this.password

      if (!this.password) {
        password = '1'
      }

      this.$emit('proceed', {
        password,
        username: this.username,
        pin: this.pin,
        captcha: this.captcha,
      })
    },
  },
}
</script>

<style lang="scss">
.captcha-input-field {
  width: 100%;
  padding: 10px 10px 10px 20px;
  outline: none;
  border: 1px solid #f1f1f1;
  box-shadow: 0px 5px 10px rgba(212, 212, 212, 0.25);
  border-radius: 8px;

  &::placeholder {
    font-size: 14px;
    color: #d8d8d8;
  }
}

.captcha-block-wrapper {
  & input:focus::placeholder {
    color: transparent;
  }
}

.captcha-img-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  width: 100%;
}
</style>
